import store, {ActionTypes} from "../store";

class TokenService {
    getLocalRefreshToken() {
        const refresh_token = localStorage.getItem("refresh");
        return refresh_token;
    }

    getLocalAccessToken() {
        const token_stored = localStorage.getItem("token");
        return token_stored;
    }

    updateLocalAccessToken(access: string, refresh: string) {
        localStorage.setItem("refresh", refresh);
        localStorage.setItem("token", access);
        store.dispatch(ActionTypes.FETCH_CURRENT_USER)
    }

    getUser() {
        return localStorage.getItem("token");
    }

    async setUser(access: string, refresh: string) {

        localStorage.setItem("token", access);

        localStorage.setItem("loggedIn", 'true');
        localStorage.setItem("refresh", refresh);


    }

    removeUser() {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("loggedIn");
    }
}

export default new TokenService();
